import { Link } from "react-router-dom";
import SectionHeader from "../../../../components/SectionHeader/SectionHeader.tsx";
import { paymentPagePath } from "../../Payments/paths.ts";
import type { LifecycleController } from "../useLifecycle.ts";
import { displayDate } from "../dates.ts";
import { CARD } from "./shared.tsx";

export function InstallmentsPanel({
  controller,
}: {
  controller: LifecycleController;
}) {
  const { schedule, policy, can } = controller;
  if (!schedule || !policy) return null;
  // The first installment is paid at issue; later ones on the payment page,
  // which also records them in Wing.
  const paymentPage = can("installments.payment")
    ? paymentPagePath(policy.provider, policy.policyNumber)
    : null;
  const hasDue = schedule.installments.some((row) => row.status === "due");
  return (
    <fieldset className={CARD}>
      <SectionHeader title="Вноски" />
      <div className="p-3 pt-2">
        {schedule.note && (
          <p className="mb-2 text-xs text-warning">{schedule.note}</p>
        )}
        {schedule.completeness === "unpaid-only" && (
          <p className="mb-2 text-xs text-warning">
            Показват се само върнатите неплатени вноски.
          </p>
        )}
        {schedule.installments.length === 0 ? (
          <p className="text-sm">Няма върнати вноски.</p>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr>
                <th scope="col" className="text-left">
                  Вноска
                </th>
                <th scope="col" className="text-left">
                  Падеж
                </th>
                <th scope="col" className="text-left">
                  Сума
                </th>
                <th scope="col" className="text-right">
                  Статус
                </th>
              </tr>
            </thead>
            <tbody>
              {schedule.installments.map((row) => (
                <tr
                  key={`${row.sequence}-${row.dueDate}`}
                  className="border-t border-stroke dark:border-strokedark"
                >
                  <td className="py-2">{row.sequence}</td>
                  <td>{displayDate(row.dueDate)}</td>
                  <td className="font-semibold">
                    {row.amount.eur.toFixed(2)} EUR /{" "}
                    {row.amount.bgn.toFixed(2)} лв.
                  </td>
                  <td className="text-right">
                    {row.status === "paid" ? (
                      <span className="text-success">Платена</span>
                    ) : row.status === "due" ? (
                      "Дължима"
                    ) : (
                      "Непотвърден статус"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {hasDue && paymentPage && (
          <Link
            to={paymentPage}
            className="mt-3 inline-block rounded bg-success px-3 py-1.5 text-xs text-white"
          >
            Плащане на вноска
          </Link>
        )}
      </div>
    </fieldset>
  );
}
